var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{attrs:{"menu":_vm.menu,"width":(_vm.width + "px"),"collapsed":_vm.collapsed},on:{"toggle-collapse":function($event){return _vm.$emit('toggle-collapse', $event)},"item-click":_vm.onItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }